import { apiFetch } from './apiClient';



export const listarContasEmail      = () => apiFetch('/email-contas');
export const criarContaEmail        = (dados) => apiFetch('/email-contas', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarContaEmail    = (id, dados) => apiFetch(`/email-contas/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirContaEmail      = (id) => apiFetch(`/email-contas/${id}`, { method: 'DELETE' });
export const testarContaEmail       = (dados) => apiFetch('/email-contas/testar', { method: 'POST', body: JSON.stringify(dados) });
export const listarPastasContaEmail = (id) => apiFetch(`/email-contas/${id}/pastas`);
